import { render } from "./BaseDatepicker.vue?vue&type=template&id=2f9d7e42"
import script from "./BaseDatepicker.vue?vue&type=script&lang=ts"
export * from "./BaseDatepicker.vue?vue&type=script&lang=ts"

import "./BaseDatepicker.vue?vue&type=style&index=0&id=2f9d7e42&lang=scss"
script.render = render

export default script